/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkBookTaskItemReportListItemVm,
    WorkBookTaskItemReportListItemVmFromJSON,
    WorkBookTaskItemReportListItemVmFromJSONTyped,
    WorkBookTaskItemReportListItemVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkBookTaskItemReportListItemVmPaginatedSearchResponse
 */
export interface WorkBookTaskItemReportListItemVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<WorkBookTaskItemReportListItemVm>}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    items?: Array<WorkBookTaskItemReportListItemVm> | null;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkBookTaskItemReportListItemVmPaginatedSearchResponse
     */
    size?: number;
}

export function WorkBookTaskItemReportListItemVmPaginatedSearchResponseFromJSON(json: any): WorkBookTaskItemReportListItemVmPaginatedSearchResponse {
    return WorkBookTaskItemReportListItemVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function WorkBookTaskItemReportListItemVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkBookTaskItemReportListItemVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(WorkBookTaskItemReportListItemVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function WorkBookTaskItemReportListItemVmPaginatedSearchResponseToJSON(value?: WorkBookTaskItemReportListItemVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(WorkBookTaskItemReportListItemVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


